export const startEndCitiesData = [
    'Mumbai',
    'Delhi',
    'Banglore',
    'Hyderabad',
    'Ahemdabad',
    'Chennai',
    'Kolkata',
    'Surat',
    'Pune',
    'Jaipur',
    'Lucknow',
    'Kanpur',
    'Nagpur',
]
